import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { JhiAlertService } from 'ng-jhipster';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
    selector: 'jhi-active-inactive-popup',
    templateUrl: './active-inactive-popup.component.html',
    styleUrls: []
})
export class ActiveInactivePopUpComponent implements OnInit, AfterViewInit {

    @Input() id: number;
    @Input() status: string;
    @Input() modalTitle: string;
    @Input() modalContent: string;
    @Output() openModal: EventEmitter<any> = new EventEmitter<any>();
    @Output() closeActiveModel = new EventEmitter<boolean>()
    constructor(private jhiAlertService: JhiAlertService) { }

    @ViewChild('activeInactiveModal') activeInactiveModal: ModalDirective;

    ngOnInit(): void {

    }
    ngAfterViewInit(): void {
        this.showActiveInactiveModal()
    }

    hideActiveInactiveModal() {
        this.closeActiveModel.emit(false);

    }

    showActiveInactiveModal() {
        this.activeInactiveModal.show()
    }


    changeStatus() {
        this.openModal.emit(this.id);
        this.closeActiveModel.emit(false);
        this.activeInactiveModal.hide()
    }

};

